import { postRequest } from "../libs/AxiosService.util";

export async function serviceCreateRoute(params) {
  return await postRequest("route/create", params);
}

export async function serviceUpdateRoute(params) {
  return await postRequest("route/update", params);
}

export async function serviceDeleteRoute(params) {
  return await postRequest("route/delete", params);
}

export async function serviceGetRouteList(params) {
  return await postRequest("route/list", params);
}

export async function serviceGetRouteDetails(params) {
  return await postRequest("route/details", params);
}

export async function serviceRouteCheck(params) {
    return await postRequest("route/isExist", params);
}
